import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import BlogComp from '../components/BlogComp.vue'
import DetailBlog from '../components/DetailBlog.vue'
import ShowcaseComp from '../components/ShowcaseComp.vue'
import DetailShowcase from '../components/DetailShowcase.vue'
import AboutUs from '../components/AboutUs.vue'
import LoginComp from '../components/LoginComp.vue'
import ListEvent from '../views/ListView.vue'
import ListService from '../components/ListService.vue'
import DetailEvent from '../components/DetailEvent.vue'
import RegisterComp from '../components/RegisterComp.vue'
import FaqComp from '../components/FaqComp.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/event',
    name: 'event',
    component: ListEvent
  },
  {
    path: '/service',
    name: 'service',
    component: ListService
  },
  {
    path: '/detail-event',
    name: 'DetailEvent',
    component: DetailEvent
  },
  {
    path: '/blog',
    name: 'BlogComp',
    component: BlogComp
  },
  {
    path: '/detail-blog',
    name: 'DetailBlog',
    component: DetailBlog
  },
  {
    path: '/showcase',
    name: 'ShowcaseComp',
    component: ShowcaseComp
  },
  {
    path: '/detail-showcase',
    name: 'DetailShowcase',
    component: DetailShowcase
  },
  {
    path: '/about',
    name: 'AboutUs',
    component: AboutUs
  },
  {
    path: '/login',
    name: 'LoginComp',
    component: LoginComp
  },
  {
    path: '/register',
    name: 'RegisterComp',
    component: RegisterComp
  },
  {
    path: '/faq',
    name: 'FaqComp',
    component: FaqComp
  },
]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes
})
  
export default router